import store from '../stores/store';
// import { type } from 'os';
import { compareDateString } from './utils';

export const LS_MEETINGS = 'bt+01';
export const LS_AGENDAS = 'bt+02_'; //Format is: LS_AGENDAS + instanceId + meetingId
export const LS_AGENDAS_DOWNLOADED = 'bt+03_'; //Format is: LS_AGENDAS_DOWNLOADED + instanceId + meetingId + userClientId
export const LS_GOVERNANCE = 'bt+04_'; //Format is: LS_GOVERNACE + instanceId + groupId
export const LS_GOVERNANCE_DOWNLOADED = 'bt+05_'; //Format is: LS_GOVERNANCE_DOWNLOADED + instanceId + groupId + userClientId
export const LS_TASKS = 'bt+06_'; //Format is: LS_TASK + instanceId + groupId
export const LOGO_PATH = 'logo_path';
export const LOGO_TIMESTAMP = 'logo_timestamp';
export const LS_WAR = 'WAR';

//#region WAR FUNCTION

export function anyWarNew() {
    let warStorage = JSON.parse(localStorage.getItem(LS_WAR));

    if (warStorage === null) {
        return false;
    }

    return (
        warStorage.filter(war => {
            return war.isNew === true;
        }).length > 0
    );
}

export function setUpWar() {
    const existingWarStorage = JSON.parse(localStorage.getItem(LS_WAR));
    const newWarStorage = [];

    const wars = store.war.data;
    wars.forEach(war => {
        const warStorageCatItemCreated = newWarStorage.filter(item => {
            return item.hasOwnProperty('parentCatId') && item.catId === war.WarCatId;
        });
        if (warStorageCatItemCreated.length > 0) {
            return;
        }

        let warStorageCatItem = {};
        const catId = war.WarCatId;
        warStorageCatItem['catId'] = catId;
        warStorageCatItem['parentCatId'] = war.ParentId;
        const existingCat =
            existingWarStorage == null
                ? null
                : existingWarStorage.filter(item => {
                      return item.hasOwnProperty('parentCatId') && item.catId === catId;
                  })[0];
        if (existingCat != null) {
            warStorageCatItem['isNew'] = existingCat['isNew'];
        } else {
            warStorageCatItem['isNew'] = true;
        }

        newWarStorage.push(warStorageCatItem);
        if (war.WarDocs.length > 0) {
            war.WarDocs.forEach(doc => {
                const existingDoc =
                    existingWarStorage == null
                        ? null
                        : existingWarStorage.filter(war => {
                              return (
                                  !war.hasOwnProperty('parentCatId') && war.docId === doc.WarDocId
                              );
                          })[0];

                const isDocNew =
                    existingDoc == null ||
                    compareDateString(existingDoc['lastModified'], doc.DocModified);

                let warStoreDocItem = {};
                warStoreDocItem['docId'] = doc.WarDocId;
                warStoreDocItem['catId'] = catId;
                if (isDocNew) {
                    warStoreDocItem['isNew'] = true;

                    warStorageCatItem['isNew'] = true;

                    markCatAsNew(wars, newWarStorage, warStorageCatItem['parentCatId']);
                } else {
                    warStoreDocItem['isNew'] = existingDoc['isNew'];
                }
                warStoreDocItem['lastModified'] = doc.DocModified;
                newWarStorage.push(warStoreDocItem);
            });
        }
    });

    localStorage.setItem(LS_WAR, JSON.stringify(newWarStorage));
}

export function areDocsNew(catId) {
    let warStorage = JSON.parse(localStorage.getItem(LS_WAR));
    const filteredDocs = warStorage.filter(war => {
        //
        return !war.hasOwnProperty('parentCatId') && war.catId === catId;
    });

    let areDocsNew = {};
    filteredDocs.forEach(war => {
        areDocsNew[war.docId] = war.isNew;
    });

    return areDocsNew;
}

export function markWarDocAsRead(docId) {
    let warStorage = JSON.parse(localStorage.getItem(LS_WAR));

    warStorage.forEach((war, index, array) => {
        if (war.docId === docId) {
            array[index]['isNew'] = false;

            const docsUnderSameCat = warStorage.filter(item => {
                return !item.hasOwnProperty('parentCatId') && item.catId === war.catId;
            });

            const shouldMarkCatAsRead = docsUnderSameCat
                .map(doc => {
                    return !doc.isNew;
                })
                .reduce((a, b) => {
                    return a && b;
                });

            if (shouldMarkCatAsRead) {
                markWarCatAsRead(warStorage, war.catId);
            }
        }
    });

    localStorage.setItem(LS_WAR, JSON.stringify(warStorage));
}

function markWarCatAsRead(warStorage, catId) {
    warStorage.forEach((war, index, array) => {
        if (war.hasOwnProperty('parentCatId') && war.catId === catId) {
            array[index]['isNew'] = false;

            const catsUnderSameCat = warStorage.filter(item => {
                return item.parentCatId === war.parentCatId;
            });

            const shouldMarkParentCatAsRead = catsUnderSameCat
                .map(cat => {
                    return !cat.isNew;
                })
                .reduce((a, b) => {
                    return a && b;
                });
            if (shouldMarkParentCatAsRead && war.parentCatId != null && war.parentCatId !== 0) {
                markWarCatAsRead(warStorage, war.parentCatId);
            }
        }
    });
}

function markCatAsNew(wars, newWarStorage, parentCatId) {
    if (parentCatId != null && parentCatId !== 0) {
        let warCatItem = {};
        warCatItem['catId'] = parentCatId;
        warCatItem['isNew'] = true;

        const warItem = wars.filter(war => {
            return war.WarCatId === parentCatId;
        })[0];

        warCatItem['parentCatId'] = warItem.ParentId;
        newWarStorage.push(warCatItem);

        markCatAsNew(wars, newWarStorage, warItem.ParentId);
    }
}

export function areChildCatsNew(parentCatId) {
    let warStorage = JSON.parse(localStorage.getItem(LS_WAR));
    const filteredWar = warStorage.filter(war => {
        return war.parentCatId === parentCatId;
    });

    let areChildCatsNew = {};
    filteredWar.forEach(war => {
        areChildCatsNew[war.catId] = war.isNew;
    });
    return areChildCatsNew;
}

//#endregion WAR

//#region MEETINGS FUNCTIONS

/******************************************************************************
setupMeetingBadges
- IHT, Oct 17
- called by MeetingStore on retrieval of meetings endpoint
- builds the local store of meeting info, comparing to anything existing as it does so
- "read" status is altered only if there has been a change in the meeting since the user last viewed the meeting
******************************************************************************/
export function setupMeetingBadges() {
    const newMeetingStorage = [];

    const companies = store.meetings.data.companies;

    for (const instanceId in companies) {
        if (companies.hasOwnProperty(instanceId)) {
            const company = companies[instanceId];
            for (const groupId in company.groups) {
                if (company.groups.hasOwnProperty(groupId)) {
                    const group = company.groups[groupId];

                    for (const meetingId in group.meetings) {
                        if (group.meetings.hasOwnProperty(meetingId)) {
                            //check to see if it already exists
                            const existingMeeting = findMeetingFromLocalStorage(
                                instanceId,
                                groupId,
                                meetingId,
                            );
                            const serverLastTouched = group.meetings[meetingId].LastTouchedDateTime;
                            //

                            let readState = false;
                            let lastTouchedState = serverLastTouched;

                            if (existingMeeting !== null) {
                                //check the timestamp
                                const userLastTouched = existingMeeting.lastTouched;

                                if (userLastTouched > serverLastTouched) {
                                    readState = existingMeeting.read;
                                    lastTouchedState = userLastTouched;
                                }
                            }
                            //
                            newMeetingStorage.push({
                                instanceId,
                                groupId,
                                meetingId,
                                read: readState,
                                lastTouched: lastTouchedState,
                            });
                        }
                    }
                }
            }
        }
    }

	localStorage.setItem(LS_MEETINGS, window.btoa(JSON.stringify(newMeetingStorage)));
}

function getMeetingBadges() {
	let meetings = localStorage.getItem(LS_MEETINGS);
	// console.log("meetings encrypted", meetings);

	if (meetings !== null) {
		try {
			meetings = window.atob(meetings);
		} catch(e) {
			// console.log("meetings not enc");
		}
		meetings = JSON.parse(meetings);
	}
	// console.log("meetings decoded", meetings);
	return meetings;
}

/******************************************************************************
findMeetingFromLocalStorage
- IHT, Oct 17
- given the 3 IDs, return the stored meeting info, or null
******************************************************************************/
export function findMeetingFromLocalStorage(instanceId, groupId, meetingId) {
	const currMeetingStorage = getMeetingBadges();
    let foundMeeting = null;

    if (currMeetingStorage !== null) {
        foundMeeting = currMeetingStorage.filter(meeting => {
            if (
                instanceId.toString() === meeting.instanceId &&
                groupId.toString() === meeting.groupId &&
                meetingId.toString() === meeting.meetingId
            ) {
                return meeting;
            }
            return null;
        });
    }
    return foundMeeting === null || foundMeeting.length === 0 ? null : foundMeeting[0];
}

/******************************************************************************
setMeetingAsRead
- IHT, Oct 17
- currently called when opening a meeting
-   ***** This will change as the app grows! ******
- given the 3 IDs, flag the meeting as read with a timestamp in utc if all
- the agenda docs have been read
******************************************************************************/
export function setMeetingAsRead(
    selectedCompany,
    selectedGroup,
    selectedMeeting,
    readDateTimeStamp,
) {
	const meetingStorage = getMeetingBadges();
    const key = LS_AGENDAS + selectedCompany + selectedMeeting + store.user.profile[0].UserId;
    const arrAgendaDocsRead = getArrayByKeyStringFromLocalStorage(key); //no this
    const docCountRead = arrAgendaDocsRead.length;
    let docCountAll = 0;

    const agenda =
        store.meetings.data.companies[selectedCompany].groups[selectedGroup].meetings[
            selectedMeeting
        ].Agenda;

    agenda.forEach(item => {
        docCountAll += item.AgendaItemDocs.length;
    });

    if (meetingStorage !== null) {
        meetingStorage.forEach(meeting => {
            if (
                selectedCompany.toString() === meeting.instanceId &&
                selectedGroup.toString() === meeting.groupId &&
                selectedMeeting.toString() === meeting.meetingId
            ) {
                if (docCountRead === docCountAll) {
                    meeting.read = true;
                    meeting.lastTouched = readDateTimeStamp;
                }
            }
        });
    }

    localStorage.setItem(LS_MEETINGS, window.btoa(JSON.stringify(meetingStorage)));
}

/******************************************************************************
countMeetingBadges
- IHT, Oct 17
- used by the ContentMenu
- counts all meetings that are unread for selected hierarchy
- this is used in the badge in the menu
******************************************************************************/
export function countMeetingBadges() {
    let meetingCount = 0;
    const selectedCompany = store.companies.selectedId;
    const selectedGroup = store.groups.selectedId;
	const meetingStorage = getMeetingBadges();

    if (meetingStorage !== null) {
        meetingStorage.forEach(meeting => {
            //
            if (selectedCompany === null || selectedCompany.toString() === meeting.instanceId) {
                if (selectedGroup === null || selectedGroup.toString() === meeting.groupId) {
                    if (!meeting.read) {
                        meetingCount++;
                    }
                }
            }
        });
    }
    return meetingCount;
}

/******************************************************************************
countMeetingBadges
- BD, Nov 17
- used by the GroupStore
- counts all meetings that are unread for passed group
- this is used to set visual indicators for groups and companies
******************************************************************************/
export function countMeetingBadgesForGroup(group) {
    let meetingCount = 0;

    const selectedCompany = group.company.InstanceId;
    const selectedGroup = group.GroupId;
	const meetingStorage = getMeetingBadges();

    if (meetingStorage !== null) {
        meetingStorage.forEach(meeting => {
            if (selectedCompany === null || selectedCompany.toString() === meeting.instanceId) {
                if (selectedGroup === null || selectedGroup.toString() === meeting.groupId) {
                    if (!meeting.read) {
                        meetingCount++;
                    }
                }
            }
        });
    }
    return meetingCount;
}

/******************************************************************************
countMeetingFilterBadges
- IHT, Oct 17
- used by the meeting status filter menu
- for each status type, counts the number of meetings and number of unread
- the unread count is used for badges, the main count is to decide whether to show the menu item
******************************************************************************/
export function countMeetingFilterBadges() {
    let upcomingCount = 0;
    let upcomingUnread = 0;
    let previousCount = 0;
    let previousUnread = 0;
    let draftCount = 0;
    let draftUnread = 0;

	const meetingStorage = getMeetingBadges();
    const meetingsFiltered = store.meetings.dataFilteredByHierarchy;

    //

    if (meetingStorage !== null) {
        meetingStorage.forEach(meeting => {
            meetingsFiltered.forEach(item => {
                //
                if (
                    meeting.meetingId === item.MeetingId.toString() &&
                    meeting.instanceId === item.InstanceId.toString()
                ) {
                    const nowLocal = new Date();
                    const endLocal = new Date(item.MoveMeetingToPrevious.replace(' +', '+'));

                    if (item.MeetingActionText.toLowerCase() === 'draft') {
                        draftCount++;
                        if (!meeting.read) {
                            draftUnread++;
                        }
                    } else if (endLocal > nowLocal) {
                        upcomingCount++;
                        if (!meeting.read) {
                            upcomingUnread++;
                        }
                    } else {
                        previousCount++;
                        if (!meeting.read) {
                            previousUnread++;
                        }
                    }
                }
            });
        });
    }
    const badgeCounts = {
        draftCount,
        draftUnread,
        upcomingCount,
        upcomingUnread,
        previousCount,
        previousUnread,
    };

    return badgeCounts;
}

//#endregion MEETINGS

//#region AGENDA FUNCTIONS

/******************************************************************************
cleanAgendaDocRead
- IHT, Oct 17
- called by MeetingStore on retrieval of meetings endpoint
- cleans up any store of Agenda docs from meetings that no longer exist
******************************************************************************/
export function cleanAgendaDocRead() {
	const meetingStorage = getMeetingBadges();
    let arrMeetingKeys = [];

    // build all the possible keys
    if (meetingStorage !== null) {
        meetingStorage.forEach(meeting => {
            //const tempKey = LS_AGENDAS + meeting.instanceId + meeting.meetingId;
            const tempKey =
                LS_AGENDAS + meeting.instanceId + meeting.meetingId + store.user.profile[0].UserId;
            arrMeetingKeys.push(tempKey);

            const tempKey2 =
                LS_AGENDAS_DOWNLOADED +
                meeting.instanceId +
                meeting.meetingId +
                store.user.profile[0].UserId;
            arrMeetingKeys.push(tempKey2);
        });
    }

    // now look through the actual keys, and ditch if not found
    for (var i = 0; i < localStorage.length; i++) {
        const lsKey = localStorage.key(i);

        if (lsKey.indexOf(LS_AGENDAS) === 0) {
            const found = arrMeetingKeys.filter(key => {
                return key === lsKey;
            });

            if (found.length === 0) {
                clearLocalStorage(lsKey); // no this
            }
            //TODO: if found, also need to clean doc IDs and any downloaded documents
        }

        if (lsKey.indexOf(LS_AGENDAS_DOWNLOADED) === 0) {
            const found = arrMeetingKeys.filter(key => {
                return key === lsKey;
            });

            if (found.length === 0) {
                clearLocalStorage(lsKey); // no this
            }
            //TODO: if found, also need to clean doc IDs and any downloaded documents
        }

        //
    }
}


//#endregion AGENDA

//#region MISC FUNCTIONS
/******************************************************************************
saveNumberByKeyStringInLocalStorageArray
- Bill, Oct 17
- governance docs
******************************************************************************/
export function saveNumberByKeyStringInLocalStorageArray(key, Id) {
    let localStorageArray = [];
    if (localStorage.getItem(key) !== null) {
        localStorageArray = JSON.parse(localStorage.getItem(key));
    }

    const keyExists = isKeyExists(key, Id);
    if (!keyExists) {
        localStorageArray.push(Id);
    }

    localStorage.setItem(key, JSON.stringify(localStorageArray));
}

/******************************************************************************
getArrayByKeyStringFromLocalStorage
- Bill, Oct 17
- governance docs
******************************************************************************/
export function getArrayByKeyStringFromLocalStorage(key) {
    let localStorageArray = [];

    if (localStorage.getItem(key) !== null) {
        localStorageArray = JSON.parse(localStorage.getItem(key));
    }

    return localStorageArray;
}

/******************************************************************************
isKeyExists
- Bill, Oct 17
- governance docs
******************************************************************************/
export function isKeyExists(key, Id) {
    const arr = getArrayByKeyStringFromLocalStorage(key);
    let flag = false;

    for (let i = 0; i <= arr.length - 1; i++) {
        if (arr[i] === Id) {
            flag = true;
            break;
        }
    }

    return flag;
}

/******************************************************************************
clearLocalStorage
- Bill, Oct 17
- clears the local storage
- this will grow over time
******************************************************************************/
export function clearLocalStorage(key) {
    localStorage.removeItem(key);

    //Following will delete EVERYTHING
    //localStorage.clear();
}
//#endregion



// WEBPACK FOOTER //
// ./src/helpers/localStorage.js